<template>
  <span>
    <div id="app">
      <v-app light>
        <v-toolbar max-height="64px">
          <v-toolbar-title>Bolsa de Trabajo</v-toolbar-title>
          <v-toolbar-title class="text--secondary mx-2 subtitle-1">Reestablecer Cuenta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="bolsa-green" text icon :to="{ name: 'Landing' }">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </v-toolbar>
        <v-main>
          <section>
            <v-container fluid class="d-flex justify-center align-center" style="height: 75vh">
              <v-row align="center" justify="center">
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex justify-center align-center">
                    <v-alert
                      type="info"
                      v-if="infoAlert"
                      style="width: 100%"
                    >Al subir el formulario, no podrás ingresar a la plataforma hasta que reestablezcas tu contraseña mediante el link que se enviará a tu correo.</v-alert>
                    <transition name="slide-fade">
                      <v-alert
                        v-if="successAlert"
                        style="width: 100%"
                        type="success"
                      >Cuenta reestablecida con éxito, te enviamos un link a tu correo electrónico para reestablecer tu contraseña.</v-alert>
                    </transition>

                    <transition name="slide-fade">
                      <div class="d-flex justify-center" v-if="successAlert">
                        <v-btn :to="{ name: 'Landing' }" color="bolsa-green" dark>
                          Ir a la Página de Inicio
                          <v-icon right dark>mdi-home</v-icon>
                        </v-btn>
                      </div>
                    </transition>
                    <transition name="slide-fade">
                      <v-alert
                        type="error"
                        v-if="getError.error"
                        style="width: 100%"
                      >Ha sucedido un error al validar la información, actualiza la página e intenta nuevamente.</v-alert>
                    </transition>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  class="d-flex align-center justify-center flex-column"
                >
                  <v-card style="width: 75%" :disabled="cardDisabled">
                    <v-card-title>Recupera tu cuenta</v-card-title>
                    <v-card-text>
                      <v-form
                        lazy-validation
                        ref="formResetAccount"
                        v-model="validationResetAccount"
                      >
                        <v-text-field
                          ref="docIdentidad"
                          v-model="body.docIdentidad"
                          :rules="[
                              () => !!body.docIdentidad || 'El Documento de Identidad es obligatorio'
                            ]"
                          label="Documento de Identidad"
                          placeholder="70101594"
                          prepend-icon="mdi-badge-account-horizontal"
                          color="bolsa-green"
                        ></v-text-field>
                        <v-text-field
                          ref="codigoUNI"
                          v-model="body.codigoUNI"
                          :rules="[
                              () => !!body.codigoUNI || 'El código UNI es obligatorio',
                              () => !!body.codigoUNI && body.codigoUNI.length <= 9 || 'El código UNI es de máximo 9 caracteres'
                            ]"
                          label="Código UNI"
                          placeholder="20101234A"
                          prepend-icon="mdi-badge-account"
                          counter="9"
                          required
                          color="bolsa-green"
                        ></v-text-field>
                        <v-autocomplete
                          ref="carreraAlumno"
                          v-model="body.carreraId"
                          :rules="[() => !!body.carreraId || 'Debes seleccionar una Especialidad']"
                          :items="carrerasDisponibles"
                          item-text="nombreEspecialidad"
                          item-value="_id"
                          label="Carrera"
                          prepend-icon="mdi-account-hard-hat"
                          placeholder="Selecciona tu Especialidad"
                          required
                          color="bolsa-green"
                        ></v-autocomplete>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        :dark="validationResetAccount"
                        block
                        class="bolsa-green"
                        :disabled="!validationResetAccount"
                        :loading="fetching"
                        @click="resetAccount"
                      >Reestablecer Cuenta</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </section>
        </v-main>
      </v-app>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      validationResetAccount: false,
      isValid: true,
      infoAlert: true,
      successAlert: false,
      body: {
        docIdentidad: "",
        codigoUNI: "",
        fechaNacimiento: "",
        carreraId: ""
      },
      cardDisabled: false,
      menuFechaSelector: false,
      fechaPicker: new Date().toISOString().substr(0, 10),
      carrerasDisponibles: []
    };
  },

  methods: {
    async resetAccount() {
      if (this.$refs.formResetAccount.validate()) {
        let { ...body } = this.body;
        let response = await this.postResetAccount(body);
        this.infoAlert = false;
        if (response.success) {
          this.successAlert = true;
          this.$refs.formResetAccount.reset();
          this.validationResetAccount = false;
          this.cardDisabled = true;
        }
      }
    },

    ...mapActions("user", ["getCarreras"]),
    ...mapActions("publicModule", ["postResetAccount"])
  },

  computed: {
    formatFechaNacimiento() {
      let splittedDate = this.fechaPicker.split("-");
      return splittedDate.reverse().join("-");
    },

    ...mapGetters("user", ["getListaCarreras", "fetching", "getError"])
  },

  async mounted() {
    this.validationResetAccount = false;
    await this.getCarreras();
    this.carrerasDisponibles = this.getListaCarreras;
  }
};
</script>

<style>
html {
  overflow: auto;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>